import { connect } from 'react-redux';
import DataMarketplaceFeeds from './components/DataMarketplaceFeeds';
import { loadMySubscriptionPlan } from '../../redux/actions/user';
import {
  loadDataMarketplaceFeeds,
  downloadDataMarketplaceFeed,
  clearDataMarketplaceFeeds,
} from '../../redux/actions/marketPlace';

const mapStateToProps = (state) => {
  return {
    mySubscriptionPlan: state.user.mySubscriptionPlan,
    mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
    dataMarketplaceFeeds: state.marketplace.dataMarketplaceFeeds,
    dataMarketplaceFeedsStatus: state.marketplace.dataMarketplaceFeedsStatus,
    dataMarketplaceDownloadStatus:
      state.marketplace.dataMarketplaceDownloadStatus,
    dataMarketplaceDownloadLink: state.marketplace.dataMarketplaceDownloadLink,
  };
};

const mapDispatchToProps = {
  loadMySubscriptionPlan,
  loadDataMarketplaceFeeds,
  downloadDataMarketplaceFeed,
  clearDataMarketplaceFeeds,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DataMarketplaceFeeds);
